export default class Agenda {

	static getHolderSelectors = () => ['section.agenda'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		const sliderElement = this.#holderElement.querySelector('.splide');
		const slider = new Splide(sliderElement, {
			arrows: false,
			pagination: false,
		});
		slider.mount();

		const controls = document.querySelectorAll('[data-slider-control]');
		controls.forEach(button => {
			button.addEventListener('click', () => {
				const index = Number.parseInt(button.dataset.sliderControl);
				slider.go(Number.isNaN(index) ? button.dataset.sliderControl : index);
				sliderElement.scrollIntoView({ behavior: "smooth" });
				controls.forEach(c => c.classList.remove('active'));

				if (!Number.isNaN(index)) {
					document.querySelectorAll(`header [data-slider-control="${index}"]`)
						.forEach(b => b.classList.add('active'));
				}
			});
		});

		const defaultDayIndex = parseInt(sliderElement.dataset.defaultDay);
		if (defaultDayIndex > 0) {
			slider.go(defaultDayIndex);
			controls.forEach(c => c.classList.remove('active'));
			document.querySelectorAll(`header [data-slider-control="${defaultDayIndex}"]`)
				.forEach(b => b.classList.add('active'));
		}


	}

}
